import * as React from 'react';
import { useState } from 'react'
import {
  Paper,
  Box,
  Drawer,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import SectionPreloader from './SectionPreloader'
import { linkMaker } from '../../lib/listUtil'
import { SearchQuery } from '../../lib/queries/search'


export default function SearchDrawer({searchOpen, setSearchOpen}) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {dbCalling, search} = useSelector((state) => state);

  const [searchText, setSearchText] = useState("");
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setSearchOpen(open);
  }

  const searchAction=()=> {
    if(!searchText || dbCalling) return;
    dispatch({type:"SAGA_SEARCH", payload:{query:SearchQuery, reset:true, q:searchText, first:20}});
  }

  const goLink=(type, node)=> {
      navigate(linkMaker(type, node.date, node.databaseId));
      setSearchOpen(false);
  }

  const handleSubmit=(e)=>{
    if(e.key === 'Enter') {
      e.preventDefault();
      searchAction();
    }

  }

  return <Drawer anchor="top" open={searchOpen} onClose={toggleDrawer(false)}>
      <Box className="search_drawer">
          <div className="search_wrapper" id="search">
            <Paper component="form" className="search_field container">
              <TextField
                label="Search 検索"
                id="outlined-start-adornment"
                sx={{ m: 1, flex:1 }}
                value={searchText}
                onKeyPress={handleSubmit}
                onChange={(e)=>setSearchText(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
              />
              <ButtonGroup>
                 <Button variant="contained" sx={{ p: '10px' }} aria-label="search" onClick={searchAction} style={{color:'black', backgroundColor:'#ffce10'}}>
                検索
              </Button>
                <Button variant="outlined" onClick={()=> setSearchOpen(false)} style={{color:'white', borderColor:"#ffce10", backgroundColor:'#122221'}}>
               X
              </Button>
              </ButtonGroup>

            </Paper>
            {dbCalling && <div className="search_loading"><SectionPreloader show={true} /></div> }
          </div>
          {
            search && search.newses && search.newses.nodes.length > 0 && <div className="search_list container news">
            <h1>NEWS</h1>
              <ul className="news_ul">
             　　{
                 search.newses.nodes.map((news, i) =>  <li key={'news'+i}><button onClick={()=> goLink("news", news)}><span>{dayjs(news.date).format("YYYY-MM-DD")}</span> {news.title}</button></li>)
               }
            </ul>
          </div>
          }
        {
          search && search.posts && search.posts.nodes.length > 0 && <div className="search_list container events">
            <h1>EVENTS</h1>
              <ul className="news_ul">
             　　{
                 search.posts.nodes.map((post, i) =>  <li key={'post'+i}><button onClick={()=> goLink("posts", post)}>
                   {
                     post.eventACF && post.eventACF.eventDate &&  <span>{dayjs(post.eventACF.eventDate).format("YYYY-MM-DD")}</span>
                   }
                   {post.title}</button></li>)
               }
            </ul>
          </div>
        }
      </Box>
    </Drawer>;
}
